import { render, staticRenderFns } from "./AssistantMessage.vue?vue&type=template&id=0e3eddf0&scoped=true"
import script from "./AssistantMessage.vue?vue&type=script&lang=js"
export * from "./AssistantMessage.vue?vue&type=script&lang=js"
import style0 from "./AssistantMessage.vue?vue&type=style&index=0&id=0e3eddf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3eddf0",
  null
  
)

export default component.exports